'use es6';

import Actions from 'AdsUI/lib/Actions';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import ColumnData from 'AdsUI/data/ColumnData';
import fetchWithEarlyRequester from 'AdsUI/lib/fetchWithEarlyRequester';
import { ENTITY_TYPE_CONVERSION_MAP } from 'AdsUI/records/reporting/ColumnRecords';
export const fetchColumnsWithEarlyRequester = () => {
  return function (dispatch) {
    wrapReduxAction(() => fetchWithEarlyRequester(ColumnData.fetch, 'table-column-order'), 'COLUMN_ORDER_FETCH', {
      dispatch
    });
  };
};
export const setColumns = (entityType, network, columnOrder) => {
  return dispatch => {
    const backEndEntityType = ENTITY_TYPE_CONVERSION_MAP[entityType];
    dispatch({
      type: Actions.COLUMN_ORDER_SET,
      payload: {
        entityType: backEndEntityType,
        network,
        columnOrder
      }
    });
    wrapReduxAction(ColumnData.update.bind(null, backEndEntityType, network, columnOrder), 'COLUMN_ORDER_SYNC', {
      dispatch
    });
  };
};